export default { sha: 'a089ffdd416673f26f2230f10d54293d2e86ccd6', buildNumber: 'undefined' }
